// richiama il json dei dati del bracket


import mAlert from '@massimo-cassandro/m-utilities/m-alert-bs5/m-alert';

export default async function (id) {
  const brkt_url = '/tornei-brackets/';

  return (async () => {
    const url = brkt_url + id;
    const response = await fetch(url);
    if (!response.ok) {
      /* eslint-disable */
      console.error('Ajax error on: ' + url);
      console.error(response);
      /* eslint-enable */
      throw 'Si è verificato un errore nel caricamento dei dati';
    }
    const data = await response.json();
    return data;
  })()
    .catch(error => {
      mAlert({
        type : 'error',
        title: 'Errore!',
        mes: error
      });
    });
}
